import  React, 
        {
            useState, 
            useEffect, 
            useRef,
            useMemo
        }                                   from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {InputGeneral}                       from "components/Field/field";
import Style                                from "components/UI/main.module.scss";
import  {   getDepartmentList,
            getUserList,
            getUserByID,
            updateUser,
            updateUserStatus,
            deleteUser,
            getDepartmentByID,
            updateDepartment,
            updateDepartmentStatus,
            deleteDepartment, 
            getAssignmentList,
            getAssignmentByID,
            updateAssignment,
            updateAssignmentStatus,
            deleteAssignment,    
            getDepartmentAssignmentList                          
        }                                   from "./usersService";
import  {   q3x_FunData, 
            validateEmail, 
            GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            ValidateBusinessRules,
            sleep,
        }                                   from "Utilities/utils";
import  {   DatePicker,
            DateToIsoString,
            InitDateToIsoString,
            InitDateFromIsoString,
            setDefaultInitDate,
            DisplayGridDatetime,
            getDateNow
        }                                   from "components/Date/date";       
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useSideContent }                   from "components/SideContent/sideContent";
import {ModalContentGoAction, ModalContent} from "components/Modal/modal";
import {TableGrid}                          from "components/Table/table";
import  {   SearchableDropdownList,
        }                                   from "components/DropdownListField/dropdownListFIeld";
import  {   StatusFilter}                   from "components/Filter/statusFilter";
import  {   NeedSaveBlock}                  from "components/Validation/needSaveBlock";
import  {   LabelModule,
            IconHistory,
        }                                   from "components/Label/label";
import  {   getSystemStatusList,
        }                                   from "Services/service";
import { Tooltip } from "antd";
import { AccessDeniedContent } from "components/Content/accessContent";

let blank_department_obj        = {
    NeedSave:       false,
    DepartmentId:   0,
    DepartmentName: "",
    StatusId:       1,
    Assignments:    [],
    Old:            [],        
    Current:        [],
};
let blank_assignment_obj        = {
    NeedSave:           false,
    AssignmentId:       0,
    AssignmentNamePt:   "",
    AssignmentNameEn:   "",
    AssignmentNameEs:   "",
    StatusId:           1
};
let blank_user_obj              = {
    NeedSave:       false,
    UserId:         0,
    Email:          "",
    FirstName:      "",
    LastName:       "",
    ModuleName:     "D",
    DepartmentId:   0,
    AssignmentId:   0,
    StatusId:       1,
    History:        1,
    Mentor:         0,
    HiredDate:      getDateNow(),
};

const appLang                   = GetAppLang();

const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
};
const BindAssignmentRowEdit     = ({ Assignment, AssignmentList, Remove }) => {

    useEffect(() => {
    }, [Assignment, AssignmentList, Remove]);

    const current = AssignmentList?.find((a) => a.AssignmentId === Assignment?.AssignmentId);

    return(
        <React.Fragment>
            <div className={[Style.row, Style.py_2].join(" ")}>
                <div className={[Style.col, Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
                    {current ? (
                        <div key={current.AssignmentId}>
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {current[`AssignmentName${appLang}`]}
                            </span>
                        </div>
                    ) : (
                        <span className={Style.fs_8}>
                            <SpinnerSmall/>
                        </span> 
                    )}
                    <div className={[Style.col, Style.d_flex, Style.justify_content_end, Style.align_items_center].join(" ")}>
                        <div
                            onClick={() => {
                                Remove(Assignment);
                            }}
                            className={[Style.icon, Style.clickable, Style.p_1].join(" ")}
                        >
                            <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[Style.small_ico_generic].join(" ")}>
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );

};
const BindAssignmentListEdit    = ({ DepartmentData, AssignmentList, Remove }) => {
    useEffect(() => {
    }, [DepartmentData, Remove]);

    useEffect(() => {
    }, [AssignmentList]);

    return(
        <React.Fragment>
            {DepartmentData?.Current?.length > 0 && (
                <div>
                    <div className={Style.py_2}>
                        <span className={[Style.fs_8, Style.text_body, Style.text_decoration_underline].join(" ")}>
                            {GetBusinessLabel("DepartmentAssignmentBind")}{":"}
                        </span>
                    </div>
                    {DepartmentData?.Current?.map((d) => {
                        return(<BindAssignmentRowEdit 
                                    Assignment={d} 
                                    AssignmentList={AssignmentList} 
                                    Remove={Remove}
                                />)
                        }
                    )}
                </div>
            )}
        </React.Fragment>
    );

};
const DepartmentEdit            = ({...setProps}) => {
    const {
        HideSideContent,
        ShowModal,
        HideModal,
        DepartmentData,
        ReFetchDepartmentList,
        AssignmentList,
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);   // Loading fetch control
    const [ departmentObj,   setDepartmentObj]                   = useState(blank_department_obj);   // User Object
    const { showToastMessage            }                        = useToastMessage();   // Toast message display

    const [message,          setMessage]                         = useState({display: false, content:""});

    const handleSave = async () => {
        setIsLoading(true);
        let payload = await updateDepartment(departmentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                if (departmentObj.DepartmentId === 0) {
                    setDepartmentObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            DepartmentId : payload.Response.Content.DepartmentId,
                        });
                    });
                }
                else {
                    setDepartmentObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                        });
                    });
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction = async () => {
        let messages = [];
        if (departmentObj?.DepartmentName?.length === 0 || departmentObj?.DepartmentName === null || departmentObj?.DepartmentName === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await ReFetchDepartmentList();
        }
    };
    const handleDelete = async () => {
        setIsLoading(true);
        let payload = await deleteDepartment(departmentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleDelete();
                    await ReFetchDepartmentList();
                    await HideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp     = departmentObj;
        tmp.StatusId = (tmp.StatusId === 1) ? 2 : 1;
        let payload = await updateDepartmentStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setDepartmentObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleStatus();
                    await ReFetchDepartmentList();
                }}
            />
        );
    };    


    const handleSelect = (assignmentId) => {
        if (assignmentId === null || assignmentId === undefined) return;

        setDepartmentObj(prev => {
            if (!prev) return prev;

            const currentItems = prev.Current || [];

            const selectedAssignment = AssignmentList?.find(item => item.AssignmentId === assignmentId);

            if (!selectedAssignment) return prev;

            const alreadyExists = currentItems.some(item => item.AssignmentId === selectedAssignment.AssignmentId);

            if (alreadyExists) {
                handleMessageDisplay(GetSystemLabel("WarningListAlreadyExists"));
            }

            return {
                ...prev,
                NeedSave: true,
                Current: alreadyExists
                    ? currentItems
                    : [...currentItems, selectedAssignment]
            };
        });
    };

    const handleRemove = (assignment) => {
        if (assignment === null || assignment === undefined) return;

        const assignmentId = typeof assignment === "object" ? assignment.AssignmentId : assignment;

        setDepartmentObj(prev => {
            if (!prev) return prev;

            const updatedItems = (prev.Current || []).filter(item => item.AssignmentId !== assignmentId);

            return {
                ...prev,
                NeedSave: true,
                Current: updatedItems
            };
        });
    };
    const handleMessageDisplay = async (msg) => {
        setMessage({
            display: true,
            content: msg,
        });

        await sleep(2000);

        // trigger fade-out only
        setMessage(prev => ({
            ...prev,
            display: false,
        }));

        // wait for animation duration (1.5s)
        await sleep(1500);

        // clear content
        setMessage({
            display: false,
            content: "",
        });
    };    

    useEffect(() => {
        const fetchData = async (obj) => {
            try {
                let payload = await getDepartmentByID(obj);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            const obj = payload?.Response?.Content;
                            setDepartmentObj(prev => {
                                return({
                                    ...prev, 
                                    ...obj,
                                    Current: obj.Assignments,
                                    Old: obj.Assignments,
                                });
                            });
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setDepartmentObj(blank_department_obj);
                setIsLoading(false);
            }
        };
        if (DepartmentData?.DepartmentId && DepartmentData.DepartmentId !== 0) {
            fetchData(DepartmentData);
        } 
        else {
            setDepartmentObj(blank_department_obj);
            setIsLoading(false);
        }
    }, [DepartmentData]);
    
    useEffect(() => {
    }, [message]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={departmentObj?.NeedSave}/>
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={departmentObj?.DepartmentName}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setDepartmentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            DepartmentName : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{departmentObj?.DepartmentName?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>

                    <div className={[Style.py_3].join(" ")}/>

                    {/* Message Display */}
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}></div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8, message.display ? Style.text_animation_fadein : Style.text_animation_fadeout].join(" ")}>
                                {message.content}
                            </span>
                        </div>
                    </div>  

                    {/* All Assignments */}
                    <div className={[Style.row, Style.my_3].join(" ")}>
                        <div className={[Style.col_lg_4, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("Assignment")}
                            </span>
                        </div>
                        <div className={[Style.col_lg_8, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetBusinessLabel("Assignment")}
                                listOfItems={
                                        AssignmentList?.map((d) => ({ value: d.AssignmentId, label: `${d[`AssignmentName${appLang}`]}`}))
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => {handleSelect(event);}}
                            />
                        </div>
                    </div>  
                    
                    <div className={[Style.py_3].join(" ")}/>                                

                    <BindAssignmentListEdit DepartmentData={departmentObj} AssignmentList={AssignmentList} Remove={handleRemove}/>  

                    <div className={[Style.py_3].join(" ")}/>

                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((departmentObj.DepartmentId !== null) && (departmentObj.DepartmentId !== undefined) && (departmentObj.DepartmentId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {departmentObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                                
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );

};
const DepartmentContent         = ({...setProps}) => {
    const { 
            ContentType, 
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            StatusList,
            SearchStatus,
            SetSearchStatus,
            DepartmentList,
            FetchDepartmentList,
            AssignmentList,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);   // Loading fetch control
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def    
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [searchText,  setSearchText]           = useState('');      // Searched text state

    const EditItem = (props) => {
        const handleData = () => {
            const obj_copy = props.data;
            ShowSideContent({
                children: (
                    <DepartmentEdit 
                        HideSideContent={HideSideContent}
                        ShowModal={ShowModal} 
                        HideModal={HideModal}
                        DepartmentData={obj_copy} 
                        ReFetchDepartmentList={FetchDepartmentList}
                        AssignmentList={AssignmentList}
                    />
                ),
                overlay: true
            });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData();}} 
                    className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[Style.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };
    const NewItem = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_department_obj));
        ShowSideContent({
            children: (
                <DepartmentEdit 
                    HideSideContent={HideSideContent}
                    ShowModal={ShowModal} 
                    HideModal={HideModal}
                    DepartmentData={obj_copy} 
                    ReFetchDepartmentList={FetchDepartmentList}
                    AssignmentList={AssignmentList}
                />
            ),
            overlay: true
        });
    };
    
    const defaultCol = [
        { 
            headerName: GetBusinessLabel("TableHeaderDepartmentData"),
            marryChildren: true,
            children: [
                {  hide: false,lockVisible: true,                        headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")                     ,cellRenderer: EditItem, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                {  hide: false,lockVisible: true,                        headerName: GetSystemLabel("Name"),                       field: "DepartmentName"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                
                {  hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`    ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "DepartmentId"               ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },            
    ].filter(Boolean);    

    useEffect(() => {
        if (!isReady) {
            setcolumnDefs(defaultCol);
            setIsReady(true);
        }
        setRowData(DepartmentList);
        setIsLoading(false);
        
    }, [DepartmentList, AssignmentList, isReady]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("DepartmentPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={FetchDepartmentList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>        
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                    
                        </div>
                    </div>                
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

const AssignmentEdit            = ({...setProps}) => {
    const {
        HideSideContent,
        ShowModal,
        HideModal,
        AssignmentData,
        ReFetchAssignmentList 
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);   // Loading fetch control
    const [ assignmentObj,   setAssignmentObj]                   = useState(blank_assignment_obj);   // User Object
    const { showToastMessage            }                        = useToastMessage();   // Toast message display

    const handleSave = async () => {
        setIsLoading(true);
        let payload = await updateAssignment(assignmentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                if (assignmentObj.AssignmentId === 0) {
                    setAssignmentObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            AssignmentId : payload.Response.Content.AssignmentId,
                        });
                    });
                }
                else {
                    setAssignmentObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                        });
                    });
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction = async () => {
        let messages = [];
        if (assignmentObj?.AssignmentNamePt?.length === 0 || assignmentObj?.AssignmentNamePt === null || assignmentObj?.AssignmentNamePt === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (assignmentObj?.AssignmentNameEn?.length === 0 || assignmentObj?.AssignmentNameEn === null || assignmentObj?.AssignmentNameEn === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (assignmentObj?.AssignmentNameEs?.length === 0 || assignmentObj?.AssignmentNameEs === null || assignmentObj?.AssignmentNameEs === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }        
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await ReFetchAssignmentList();
        }
    };
    const handleDelete = async () => {
        setIsLoading(true);
        let payload = await deleteAssignment(assignmentObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleDelete();
                    await ReFetchAssignmentList();
                    await HideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp     = assignmentObj;
        tmp.StatusId = (tmp.StatusId === 1) ? 2 : 1;
        let payload = await updateAssignmentStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setAssignmentObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleStatus();
                    await ReFetchAssignmentList();
                }}
            />
        );
    };    

    useEffect(() => {
        const fetchData = async (obj) => {
            try {
                let payload = await getAssignmentByID(obj);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            const obj = payload?.Response?.Content;
                            setAssignmentObj(prev => {
                                return({
                                    ...prev, 
                                    ...obj
                                });
                            });
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setAssignmentObj(blank_assignment_obj);
                setIsLoading(false);
            }
        };
        if (AssignmentData?.AssignmentId && AssignmentData.AssignmentId !== 0) {
            fetchData(AssignmentData);
        } 
        else {
            setAssignmentObj(blank_assignment_obj);
            setIsLoading(false);
        }
    }, [AssignmentData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={assignmentObj?.NeedSave}/>
                    {/* Pt */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={assignmentObj?.AssignmentNamePt}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAssignmentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AssignmentNamePt : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{assignmentObj?.AssignmentNamePt?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>
                    <div className={[Style.py_3].join(" ")}/>
                    {/* En */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("English")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={assignmentObj?.AssignmentNameEn}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAssignmentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AssignmentNameEn : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{assignmentObj?.AssignmentNameEn?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>   
                    <div className={[Style.py_3].join(" ")}/>
                    {/* Es */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Spanish")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={assignmentObj?.AssignmentNameEs}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setAssignmentObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            AssignmentNameEs : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{assignmentObj?.AssignmentNameEs?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                                        

                    <div className={[Style.py_3].join(" ")}/>
                            
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((assignmentObj.AssignmentId !== null) && (assignmentObj.AssignmentId !== undefined) && (assignmentObj.AssignmentId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {assignmentObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                                
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );

};
const AssignmentContent         = ({...setProps}) => {
    const { 
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            StatusList,
            SearchStatus,
            SetSearchStatus,
            AssignmentList,
            FetchAssignmentList,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);   // Loading fetch control
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def    
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [searchText,  setSearchText]           = useState('');      // Searched text state

    const EditItem = (props) => {
        const handleData = () => {
            const obj_copy = props.data;
            ShowSideContent({
                children: (
                    <AssignmentEdit 
                        HideSideContent={HideSideContent}
                        ShowModal={ShowModal} 
                        HideModal={HideModal}
                        AssignmentData={obj_copy} 
                        ReFetchAssignmentList={FetchAssignmentList}
                    />
                ),
                overlay: true
            });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData();}} 
                    className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[Style.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };
    const NewItem = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_assignment_obj));
        ShowSideContent({
            children: (
                <AssignmentEdit 
                    HideSideContent={HideSideContent}
                    ShowModal={ShowModal} 
                    HideModal={HideModal}
                    AssignmentData={obj_copy} 
                    ReFetchAssignmentList={FetchAssignmentList}
                />
            ),
            overlay: true
        });
    };
    
    const defaultCol = [
        { 
            headerName: GetBusinessLabel("TableHeaderAssignmentData"),
            marryChildren: true,
            children: [
                {  hide: false,lockVisible: true,                        headerName: GetSystemLabel("Edit"),                                                                field: GetSystemLabel("Edit")                     ,cellRenderer: EditItem, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                {  hide: false,lockVisible: true,                        headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Portuguese")}`,                           field: "AssignmentNamePt"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                
                {  hide: false,lockVisible: true,                        headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("English")}`,                              field: "AssignmentNameEn"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                {  hide: false,lockVisible: true,                        headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Spanish")}`,                              field: "AssignmentNameEs"             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                                
                {  hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                                                            field: `StatusName${GetAppLang()}`,    filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),           field: "AssignmentId"               ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),            field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),          field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),           field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },            
    ].filter(Boolean);    

    useEffect(() => {
        if (!isReady) {
            setcolumnDefs(defaultCol);
            setIsReady(true);
        }
        setRowData(AssignmentList);
        setIsLoading(false);
        
    }, [AssignmentList, isReady]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("AssignmentPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={FetchAssignmentList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>        
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                    
                        </div>
                    </div>                
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

const UserEdit                  = ({...setProps}) => {
    const {
        HideSideContent,
        ShowModal,
        HideModal,
        UserData,
        DepartmentList,
        ReFetchUserList 
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);   // Loading fetch control
    const [ userObj,         setUserObj]                         = useState(blank_user_obj);   // User Object
    const { showToastMessage            }                        = useToastMessage();   // Toast message display
    const [ assignmentList,  setAssignmentList]                  = useState([]);

    const departmentObj = () => {
        if (!DepartmentList && Array.isArray(DepartmentList)) return null;        
        const _departmentObj = DepartmentList?.find(d => userObj?.DepartmentId === d?.DepartmentId);
        if (_departmentObj) {
            return (_departmentObj);
        }
    };
    const assignmentObj = () => {
        if (!assignmentList && Array.isArray(assignmentList)) return null;        
        const _assignmentObj = assignmentList?.find(d => userObj?.AssignmentId === d?.AssignmentId);
        if (_assignmentObj) {
            return (_assignmentObj);
        }
    };

    const handleSave = async () => {
        setIsLoading(true);
        let payload = await updateUser(userObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                if (userObj.UserId === 0) {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave:   false,
                            UserId :    payload.Response.Content.UserId,
                        });
                    });
                }
                else {
                    setUserObj(prev => {
                        return({
                            ...prev,
                            NeedSave:   false,
                        });
                    });
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction = async () => {
        let messages = [];
        if (!userObj.Email || !validateEmail(userObj.Email)) {
            messages.push(`${GetSystemLabel("EmailInvalid")} ${userObj.Email}`);
        }
        if (userObj?.FirstName?.length === 0 || userObj?.FirstName === null || userObj?.FirstName === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (userObj?.DepartmentId === 0 || userObj?.DepartmentId === null || userObj?.DepartmentId === undefined || departmentObj() === undefined) {
            messages.push(GetBusinessLabel("WarningMessage8"));
        }
        if (userObj?.AssignmentId === 0 || userObj?.AssignmentId === null || userObj?.AssignmentId === undefined || assignmentObj() === undefined) {
            messages.push(GetBusinessLabel("WarningMessage9"));
        }        
        if (userObj?.ModuleName === "" || userObj?.ModuleName === null || userObj?.ModuleName === undefined) {
            messages.push(GetBusinessLabel("WarningMessage0"));
        }
        if (userObj?.HiredDate === "" || userObj?.HiredDate === null || userObj?.HiredDate === undefined) {
            messages.push(GetBusinessLabel("WarningMessage14"));
        }

        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await ReFetchUserList();
        }
    };
    const handleDelete = async () => {
        setIsLoading(true);
        let payload = await deleteUser(userObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleDelete();
                    await ReFetchUserList();
                    await HideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp     = userObj;
        tmp.StatusId = (tmp.StatusId === 1) ? 2 : 1;
        let payload = await updateUserStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setUserObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await ShowModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await HideModal();
                    await handleStatus();
                    await ReFetchUserList();
                }}
            />
        );
    };
    const handleDepartmentSelection = async (event) => {
        // handle List Clear
        if (event === undefined) {
            setUserObj(prev => ({
                ...prev,
                NeedSave: true,
                DepartmentId: 0,
                AssignmentId: 0
            }));
            return;
        }

        const department = DepartmentList.find(d => d.DepartmentId === event);

        if (!department) return;

        setAssignmentList(department.Assignments);

        setUserObj(prev => ({
            ...prev,
            NeedSave: true,
            DepartmentId: department.DepartmentId,
            AssignmentId: 0
        }));
    };

    useEffect(() => {
        const fetchData = async (user_id) => {
            try {
                let payload = await getUserByID(user_id);
                if (payload) {
                    if (payload?.Status?.Code === 0) {
                        if (payload?.Response?.Content) {
                            const obj = payload.Response.Content; 
                            setUserObj(prev => {
                                return({
                                    ...prev,
                                    ...obj,
                                })
                            });
                            const department = DepartmentList.find(d => d.DepartmentId === obj.DepartmentId);
                            if (department) {
                                setAssignmentList(department.Assignments);
                            }
                            setIsLoading(false);
                        }
                    }
                    else {
                        ShowModal(<ModalContent Message={payload.Status.Message}/>);
                        setIsLoading(false);
                    }
                }
            } 
            catch (error) {
                setUserObj(blank_user_obj);
                setIsLoading(false);
            }
        };
        if (UserData?.UserId && UserData.UserId !== 0) {
            fetchData(UserData);
        } 
        else {
            setUserObj(blank_user_obj);
            setIsLoading(false);
        }
    }, [UserData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={userObj?.NeedSave}/>
                    {/* First Name  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={userObj?.FirstName}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setUserObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            FirstName : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{userObj?.FirstName?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                      
                    
                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Last Name  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("LastName")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={userObj?.LastName}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setUserObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            LastName : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("LastName")}
                                maxLength={150}
                            />
                        </div>
                    </div>    
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{userObj?.LastName?.length} {GetSystemLabel("of")} 150 {GetSystemLabel("Characters")}.</span>                            
                        </div>
                    </div>                      

                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Email  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>                                
                                {GetSystemLabel("Email")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={userObj?.Email?.toLowerCase()}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setUserObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            Email : q3x_FunData(event.target.value.toLowerCase()),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Email")}
                                maxLength={320}
                            />
                        </div>
                    </div>    
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{userObj?.Email?.length} {GetSystemLabel("of")} 320 {GetSystemLabel("Characters")}.</span>  
                        </div>
                    </div>                   

                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Department  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("Department")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetBusinessLabel("Department")}                                
                                listOfItems={
                                    DepartmentList && Array.isArray(DepartmentList)
                                    ? 
                                        DepartmentList.map((d) => ({ value: d.DepartmentId, label: d.DepartmentName }))
                                    : 
                                        null
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => { 
                                    handleDepartmentSelection(event);
                                }}
                                value={departmentObj?.DepartmentId}
                            />
                        </div>
                    </div>

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Assignment  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("Assignment")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <SearchableDropdownList    
                                placeholder={GetBusinessLabel("Assignment")}                                
                                listOfItems={
                                    assignmentList && Array.isArray(assignmentList)
                                    ? 
                                        assignmentList.map((d) => ({ value: d.AssignmentId, label: d[`AssignmentName${appLang}`] }))
                                    : 
                                        null
                                }
                                style={{ width: "100%" }}  
                                className={Style.antd_custom_select}                               
                                popupClassName={Style.antd_custom_select}                              
                                onChange={(event) => {            
                                    setUserObj(prev => ({
                                        ...prev,
                                        NeedSave: true,
                                        AssignmentId: event
                                    }));
                                }}
                                value={assignmentObj?.AssignmentId}
                            />
                        </div>
                    </div>
                    
                    <div className={[Style.py_2].join(" ")}/>
                    
                    {/* Hired Date  */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("HiringDate")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <DatePicker
                                mode="date"
                                value={
                                    userObj ? 
                                        userObj.HiredDate !== null ?
                                            InitDateFromIsoString(userObj.HiredDate)
                                        :
                                            getDateNow()
                                    : 
                                        getDateNow()
                                }
                                placeholder={GetBusinessLabel("SelectDateLabel1")}
                                style={{ width: "100%" }}
                                className={[Style.mt_2].join(" ")}
                                onChange={(date) => {
                                    const data = date === undefined ? DateToIsoString(setDefaultInitDate()) : date;
                                    setUserObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            HiredDate : InitDateToIsoString(data),
                                        });
                                    });
                                }}
                            />
                        </div>
                    </div>           
                    
                    <div className={[Style.py_2].join(" ")}/>

                    {/* History  */}
                    <Tooltip title={`${GetBusinessLabel("UserHistoryTooltip")}`}>
                        <div className={Style.row}>
                            <div className={[Style.col, Style.d_flex, Style.align_items_center].join(" ")}>
                                <span className={[Style.text_body, Style.fs_8].join(" ")}>                                
                                    {GetSystemLabel("History")}
                                </span>
                            </div>
                            <div className={[Style.col, Style.d_flex, Style.align_items_center].join(" ")}>
                                <input
                                    type="checkbox"
                                    name={"read"}
                                    checked={userObj?.History === 1 ? true : false}
                                    onChange={()=> {
                                        userObj?.History === 1? 
                                            setUserObj(prev => {
                                                return({
                                                    ...prev,
                                                    NeedSave: true,
                                                    History : 0,
                                                });
                                            })
                                        : 
                                            setUserObj(prev => {
                                                return({
                                                    ...prev,
                                                    NeedSave: true,
                                                    History : 1,
                                                });
                                            })
                                    }}
                                    style={{ transform: "scale(1.5)" }}
                                    disabled={false}
                                />                            
                            </div>
                        </div>                        
                        <div className={[Style.py_2].join(" ")}/>
                    </Tooltip>

                    {/* Mentor  */}
                    <Tooltip title={`${GetBusinessLabel("UserManagerTooltip")}`}>
                        <div className={Style.row}>
                            <div className={[Style.col, Style.d_flex, Style.align_items_center].join(" ")}>
                                <span className={[Style.text_body, Style.fs_8].join(" ")}>                                
                                    {GetBusinessLabel("Mentor")}
                                </span>
                            </div>
                            <div className={[Style.col, Style.d_flex, Style.align_items_center].join(" ")}>
                                <input
                                    type="checkbox"
                                    name={"read"}
                                    checked={userObj?.Mentor === 1 ? true : false}
                                    onChange={()=> {
                                        userObj?.Mentor === 1? 
                                            setUserObj(prev => {
                                                return({
                                                    ...prev,
                                                    NeedSave: true,
                                                    Mentor : 0,
                                                });
                                            })
                                        : 
                                            setUserObj(prev => {
                                                return({
                                                    ...prev,
                                                    NeedSave: true,
                                                    Mentor : 1,
                                                });
                                            })
                                    }}
                                    style={{ transform: "scale(1.5)" }}
                                    disabled={false}
                                />                            
                            </div>
                        </div>                        
                        <div className={[Style.py_3].join(" ")}/>
                    </Tooltip>
                            
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((userObj.UserId !== null) && (userObj.UserId !== undefined) && (userObj.UserId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {userObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                                
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );

};
const UserContent               = ({...setProps}) => {
    const { ContentType, 
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            StatusList,
            SearchStatus,
            SetSearchStatus,
            DepartmentList,
            FetchDepartmentList,
            
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);     
    // Loading State    
    const [ isLoading,  setIsLoading]            = useState(true);      // Loading fetch control
    const [columnDefs,  setcolumnDefs]           = useState([]);        // State of columns def    
    const [rowData,     setRowData]              = useState([]);        // State of rows def 
    const [searchText,  setSearchText]           = useState('');        // Searched text state
    const departmentListRef = useRef(DepartmentList);
    
    const reFetchUserList = async () => {
        try {
            let payload = await getUserList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const EditItem = (props) => {
        const handleData = () => {
            const currentDeps = departmentListRef.current;

            if (!currentDeps || currentDeps.length === 0) {
                ShowModal(<ModalContent Message={`${GetBusinessLabel("DepartmentListWarning_0")}`} />);
                return;
            }

            let obj_copy = JSON.parse(JSON.stringify(blank_user_obj));
            obj_copy.UserId = props.data.UserId;

            ShowSideContent({
                children: (
                    <UserEdit 
                        HideSideContent={HideSideContent}
                        ShowModal={ShowModal} 
                        HideModal={HideModal}
                        UserData={obj_copy} 
                        DepartmentList={currentDeps}
                        ReFetchUserList={() => {reFetchUserList();}}
                    />
                ),
                overlay: true
            });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData();}} 
                    className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[Style.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };
    const NewItem = () => {
        const currentDeps = departmentListRef.current;
        if (!currentDeps || currentDeps.length === 0) {
            ShowModal(<ModalContent Message={`${GetBusinessLabel("DepartmentListWarning_0")}`} />);
            return;
        }
        const obj_copy = JSON.parse(JSON.stringify(blank_user_obj));
        ShowSideContent({
            children: (
                <UserEdit 
                    HideSideContent={HideSideContent}
                    ShowModal={ShowModal} 
                    HideModal={HideModal}
                    UserData={obj_copy} 
                    DepartmentList={currentDeps}
                    ReFetchUserList={() => {reFetchUserList();}}
                />
            ),
            overlay: true
        });
    };

    const defaultCol = [
        {
            headerName: GetBusinessLabel("TableHeaderPersonData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")                     ,cellRenderer: EditItem, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Email"),                      field: "Email"                      ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("Name"),                       field: "FirstName"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("LastName"),                  field: "LastName"                   ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true,  
                    columnGroupShow: 'open', 
                    headerName: GetSystemLabel("Profile"),             
                    field: "ProfileName",
                    cellRenderer: (params) => (
                        <LabelModule
                            value={params?.data?.ProfileName} 
                        />
                    ),
                    filter: false, 
                    flex: 0, 
                    cellClass: [Style.table_text_left].join(" ")
                },
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetBusinessLabel("Department"),       field: "DepartmentName",            filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetBusinessLabel("Assignment"),       field: `AssignmentName${appLang}`,  filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("Status"),             field: `StatusName${appLang}`    ,  filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,
                    columnGroupShow: 'open', 
                    headerName: GetSystemLabel("History"),
                    width: 100,
                    wrapText: true,
                    autoHeight: true,
                    headerClass: Style.table_header_center, 
                    field: "History",
                    cellRenderer: (params) => (
                        <IconHistory
                            Boolean={params?.data?.History === 1? true:false} 
                        />
                    ),
                    cellClass: [Style.table_text_center].join(" ")
                },                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetBusinessLabel("HiringDate"),        field: "HiredDate"                  ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                       
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "UserId"                     ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },            
    ].filter(Boolean);

    const fetchUserList = async () => {
        try {
            let payload = await getUserList();
            if (payload) {
                if (payload.Status.Code == 0) {
                    setcolumnDefs(defaultCol);
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                ShowModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchUserList();
            FetchDepartmentList();
        }
    }, [ContentType, isReady]);

    useEffect(() => {
        departmentListRef.current = DepartmentList;
    }, [DepartmentList]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("UserPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={reFetchUserList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>                
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                            
                        </div>
                    </div>                   
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

export const UsersPage          = () => {
    const [ contentType,     setContentType          ]       = useState(1);
    const [ mount,           setMount                ]       = useState(false);
    const [ statusList,      setStatusList           ]       = useState(null);
    const [ departmentList,  setDepartmentList       ]       = useState([]);
    const [ assignmentList,  setAssignmentList       ]       = useState([]);
    const { showSideContent, hideSideContent         }       = useSideContent();    
    const { showModal,       hideModal               }       = useModal();
    const { showLoader,      hideLoader              }       = useLoader();
    const [ access,          setAccess               ]       = useState(false);
    const [searchStatus,     setSearchStatus         ]       = useState({StatusIds: []});

    const [ structuredList,  setStructuredList       ]       = useState([]);    

    const fetchDepartmentList = async () => {
        try {
            let payload = await getDepartmentList(searchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {                
                    const department = payload.Response.Content;
                    setDepartmentList(department);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const fetchAssignmentList = async () => {
        try {
            let payload = await getAssignmentList(searchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {                
                    const assignment = payload.Response.Content;
                    setAssignmentList(assignment);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const fetchStatusList = async () => {
        try {
            let data = await getSystemStatusList({type: 1});
            if (data) {
                setStatusList(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const fetchStructuredList = async () => {
        try {
            let payload = await getDepartmentAssignmentList({StatusIds: [1]});
            if (payload) {
                if (payload.Status.Code == 0) {                
                    const assignment = payload.Response.Content;
                    setStructuredList(assignment);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if(!mount) {
            if (ValidateBusinessRules("B")) {
                setAccess(true);
                fetchStatusList();
                fetchDepartmentList();
                fetchAssignmentList();
                fetchStructuredList();
            }
            setMount(true);
        }
    }, [contentType]);

    return (
        access ? 
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control].join(" ")}>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                                onClick={() => setContentType(1)}
                            >
                            <span 
                                className={[                                
                                    (contentType === 1) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 1) ? Style.text_decoration_underline   : null, 
                                    (contentType === 1) ? Style.fw_semibold                 : null,
                                    (contentType === 1) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetSystemLabel("Users")}
                            </span>
                        </div>                            
                    </div>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(2)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 2) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 2) ? Style.text_decoration_underline   : null, 
                                    (contentType === 2) ? Style.fw_semibold                 : null,
                                    (contentType === 2) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetBusinessLabel("Departments")}
                            </span>
                        </div>                            
                    </div>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(3)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 3) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 3) ? Style.text_decoration_underline   : null, 
                                    (contentType === 3) ? Style.fw_semibold                 : null,
                                    (contentType === 3) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {"Funções"}
                            </span>
                        </div>                            
                    </div>                    
                </div>
            {
                contentType === 1? 
                    <React.Fragment>
                        <UserContent 
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                            DepartmentList={structuredList}
                            FetchDepartmentList={fetchStructuredList}
                        />
                    </React.Fragment>
                : 
                contentType === 2? 
                    <React.Fragment>
                            <DepartmentContent 
                                ShowSideContent={showSideContent} 
                                HideSideContent={hideSideContent}
                                ShowModal={showModal} 
                                HideModal={hideModal}
                                ShowLoader={showLoader} 
                                HideLoader={hideLoader} 
                                ContentType={contentType}
                                StatusList={statusList}
                                SearchStatus={searchStatus}
                                SetSearchStatus={setSearchStatus}
                                DepartmentList={departmentList}
                                FetchDepartmentList={fetchDepartmentList}
                                AssignmentList={assignmentList}
                            />
                    </React.Fragment>
                :         
                contentType === 3? 
                    <React.Fragment>
                            <AssignmentContent 
                                ShowSideContent={showSideContent} 
                                HideSideContent={hideSideContent}
                                ShowModal={showModal} 
                                HideModal={hideModal}
                                ShowLoader={showLoader} 
                                HideLoader={hideLoader} 
                                ContentType={contentType}
                                StatusList={statusList}
                                SearchStatus={searchStatus}
                                SetSearchStatus={setSearchStatus}
                                AssignmentList={assignmentList}
                                FetchAssignmentList={fetchAssignmentList}
                            />
                    </React.Fragment>
                :                         
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};